import * as React from 'react'

export const LineIcon = (props: React.ComponentProps<'svg'> | any) => {
  return (
    <svg {...props} viewBox="0 0 28 28" width="28" height="28">
      <path
        fill="currentColor"
        d="M11.982 16.689L17.192 12h3.033l4.149-4.668-.748-.664L19.776 11h-2.968l-4.79 4.311L9 12.293l-4.354 4.353.708.708L9 13.707z"
      />
    </svg>
  )
}
